<!-- eslint-disable max-lines -->
<template>
    <div class="manage-desk-container" v-loading="loading">
        <div class="desk-header">
            <div class="desk-header-left">
                Hi，{{ supplier.supplierNameCn }}-{{ user.userName }}，欢迎回来！
            </div>
            <div class="desk-header-right">
                <span
                    class="desk-header-btn bigData-btn-refresh"
                    @click="onRefresh"
                >
                    <i class="refresh-icon"></i>
                </span>
                <span
                    class="desk-header-btn last-btn bigData-btn-config"
                    @click="onConfiguration"
                >
                    <i
                        :class="{
                            'configuration-icon': !isConfig,
                            'configuration-ok-icon': isConfig
                        }"
                    ></i>
                </span>
            </div>
        </div>
        <div class="desk-content">
            <div
                class="desk-content-notice"
                v-if="!noticeData.isRemove"
                v-has="noticeData.auth"
            >
                <DeskNotice
                    :isConfig="isConfig"
                    :noticeData="noticeData"
                    :maxHeight="noticeHeight"
                    @on-delete="onDelete"
                    @on-all-detail="onAllNoticeDetail"
                ></DeskNotice>
            </div>
            <div
                class="desk-content-tabs"
                v-if="!bidTabsData.isRemove"
                :style="tabsWidth"
            >
                <DeskTabs
                    :isConfig="isConfig"
                    :tabsData="bidTabsData"
                    @on-delete="onDelete"
                    @onSubChange="onBidSubChange"
                    @onChange="onBidTabsChange"
                >
                    <template v-slot:default="slotProps">
                        <el-table
                            :data="bidTableData"
                            :height="175"
                            empty-text="暂无数据"
                            stripe
                            show-overflow-tooltip
                            class="custom-table"
                            style="width: 100%"
                        >
                            <el-table-column
                                show-overflow-tooltip
                                prop="bidNo"
                                label="招标项目编码"
                            ></el-table-column>
                            <el-table-column
                                show-overflow-tooltip
                                prop="bidName"
                                label="招标项目名称"
                            ></el-table-column>
                            <el-table-column
                                show-overflow-tooltip
                                prop="depositEndTime"
                                label="保证金提交截止时间"
                            ></el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button
                                        :class="
                                            'bigData-btn-view-' +
                                                slotProps.tabsCode
                                        "
                                        @click="onBidView(scope.row)"
                                        type="text"
                                        >去查看</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </DeskTabs>
            </div>
            <div
                class="desk-content-tabs"
                v-if="!signTabsData.isRemove"
                v-has="signTabsData.auth"
                :style="tabsWidth"
            >
                <!-- 签署合同 -->
                <DeskTabs
                    :isConfig="isConfig"
                    :tabsData="signTabsData"
                    @on-delete="onDelete"
                    @onSubChange="onSignSubChange"
                    @onChange="onSignTabsChange"
                >
                    <template v-slot:default="slotProps">
                        <el-table
                            v-if="
                                slotProps.tabsCode === 'pendingContractSigning'
                            "
                            :data="signTableData"
                            :height="175"
                            empty-text="暂无数据"
                            stripe
                            show-overflow-tooltip
                            class="custom-table"
                            style="width: 100%"
                        >
                            <el-table-column
                                show-overflow-tooltip
                                prop="contractCode"
                                label="合同编码"
                            ></el-table-column>
                            <el-table-column
                                show-overflow-tooltip
                                prop="suppliersName"
                                label="供应商名称"
                            ></el-table-column>
                            <el-table-column
                                show-overflow-tooltip
                                prop="_contractStatus"
                                label="合同状态"
                            ></el-table-column>
                            <el-table-column
                                show-overflow-tooltip
                                prop="_businessType"
                                label="业务类型"
                            ></el-table-column>
                            <el-table-column label="操作" width="180">
                                <template slot-scope="scope">
                                    <el-button
                                        :class="
                                            'bigData-btn-view-' +
                                                slotProps.tabsCode
                                        "
                                        @click="onSignView(scope.row)"
                                        type="text"
                                        >去查看</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 待支付合同押金列表 -->
                        <NoPaymentContractDepositTable ref="noPaymentContractDepositTableRef" v-show="slotProps.tabsCode === 'noPaymentContractDeposit'" />
                    </template>
                </DeskTabs>
            </div>
            <div class="desk-content-wrap" :style="todoWrapWidth">
                <template v-for="(item, index) in todoList">
                    <div
                        class="desk-content-todo"
                        :index="index"
                        :laen="todoList.length - 1"
                        :class="
                            index === todoList.length - 1
                                ? 'todo-last-child'
                                : ''
                        "
                        :style="todoWidth"
                        v-if="!item.isRemove"
                        v-has="item.auth"
                        :key="item.code"
                    >
                        <TodoList
                            :todoData="item"
                            :isConfig="isConfig"
                            @on-delete="onDelete"
                            @on-todo-view="onTodoView"
                        ></TodoList>
                    </div>
                </template>
                <div
                    class="desk-content-addbtn"
                    v-if="isConfig"
                    :style="todoWidth"
                >
                    <div
                        class="add-mod-btn bigData-btn-add"
                        @click="onAddModule"
                    >
                        <div class="add-mod-btn-inner">
                            <i class="add-mod-btn-icon el-icon-plus"></i>
                            <span class="add-mod-btn-text">添加展示模块</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ConfigDialog ref="configDialog" @onConfig="onConfig"></ConfigDialog>
    </div>
</template>
<script>
import DeskTabs from './components/DeskTabs.vue';
import DeskNotice from './components/DeskNotice.vue';
import TodoList from './components/TodoList.vue';
import ConfigDialog from './components/ConfigDialog.vue';
import NoPaymentContractDepositTable from './components/NoPaymentContractDepositTable.vue';
import { dictWithUrl } from '@/components/lots/api';
import {
    getList,
    getTenderInfo,
    bidHomePage,
    getContractInfo,
    contractHomePage,
    supplierNoticeHomePage,
    performanceHomePageCount,
    supplierDriverHomePageCount,
    selectDealTodoCountOrder,
    getDispatchCreateCount,
    getDispatchLoadedCount,
    queryOneTheWayCount,
    carReviewRejectCount,
    driverHomePageCount,
    queryUnUploadedCount,
    queryUnconfirmedCount
} from './manageDaskApi';
import { moduleList } from './todoList.js';
import { setFinancialToDoNum } from './bmsFinancialToDo.js';
import { mapGetters } from 'vuex';

const BIDTABSCONST = {
    SIGNUP: 1, // 已报名待购标书
    BOND: 2, // 待缴纳投标保证金
    SEALSTAMP: 3, // 待盖章应标文件
    QUOTATION: 4 // 待报价项目
};

const SIGNTABSCONST = {
    TOBESIGNED: 1 // 待签署合同
};
export default {
    name: 'index',

    components: { DeskTabs, DeskNotice, TodoList, ConfigDialog, NoPaymentContractDepositTable },
    provide() {
        return {
            linkToPointPage: this.linkToPointPage
        };
    },
    data() {
        return {
            loading: false,
            tabData: [],
            dicData: {}, // 字典值
            moduleList,
            noticeData: moduleList[0],
            bidTabsData: moduleList[1],
            signTabsData: moduleList[2],
            todoList: moduleList.filter(obj => obj.type === 'todo'),
            isConfig: false,
            pageId: 'manage-desk-home-pageid',
            moduleCode: 'RE202002280094',
            pageNo: 1,
            pageSize: 1000,
            bidTabsType: BIDTABSCONST.SIGNUP,
            bidTableData: [],

            signTabsType: SIGNTABSCONST.TOBESIGNED, // 签署tabs类别
            signTableData: [],
            authLinkList: [],
            hasPermissions: false
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'supplier',
            'currentTenant',
            'menus',
            'btnPermissions',
            'authority'
        ]),
        todoWidth() {
            const newtodo = this.todoList.filter(obj => !obj.isRemove);
            const tabsList = this.moduleList.filter(
                obj => !obj.isRemove && obj.type === 'tabs'
            );
            const tabsLen = tabsList.length;

            const len = newtodo.length;
            let wd = 100;

            if (len) {
                wd = 100 / len;
            }
            if (!tabsLen && len > 1) {
                wd = 50;
            }

            return `width: calc(${wd}% - 8px);`;
        },
        todoWrapWidth() {
            const tabsList = this.moduleList.filter(
                obj => !obj.isRemove && obj.type === 'tabs'
            );
            const len = tabsList.length;
            let wd = 100;
            if (!len && !this.noticeData.isRemove) {
                wd = 75;
                return `width: calc(${wd}%);`;
            }
            return `width: calc(${wd}%);`;
        },
        tabsWidth() {
            let wd = 100;
            if (!this.noticeData.isRemove) {
                wd = 75;
                return `width: calc(${wd}% - 8px);`;
            }
            return `width: ${wd}%;`;
        },
        noticeHeight() {
            const tabsList = this.moduleList.filter(
                obj => !obj.isRemove && obj.type === 'tabs'
            );
            const len = tabsList.length;
            let height = 494;
            if (len === 1 && this.isConfig) {
                height = 133;
            } else if (len === 1 && !this.isConfig) {
                height = 170;
            } else if (len < 1 && this.isConfig) {
                height = 652;
            } else if (len < 1 && !this.isConfig) {
                height = 617;
            } else if (len > 1) {
                height = 494;
            }
            return `max-height: ${height}px;height:${height}px;`;
        }
    },
    mounted() {
        // 合同状态 SRM_CONTRACT_STATUS
        // 业务类型 BID_BUSINESS_TYPE
        dictWithUrl('SRM_CONTRACT_STATUS,BID_BUSINESS_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dicData = res.data;
                this.onRefresh();
            }
        });

        if (Array.isArray(this.authority)) {
            const allList = [];
            this.findValueRecursive(this.authority, allList);
            this.authLinkList = allList;
        }
    },
    methods: {
        onRefresh() {
            this.getConfig();
            this.getTenderInfoData();
            this.getBidHomePage();
            this.getContractHomePage();
            this.getContractInfoData();
            this.getSupplierNoticeHomePage();
            this.getPerformanceHomePageCount();
            this.getSupplierDriverHomePageCount();
            this.getCarHomePageCount()
            this.getDriverHomePageCount()
            this.getAmsHomePageCount();
            this.getTmsHomePageCount();
            this.getSupplierNoticeHomePageProject();
            setFinancialToDoNum();
        },
        getCarHomePageCount(){
            carReviewRejectCount({supplierCode: this.supplier.supplierCode}).then(res => {
                if (res && +res.code === 0) {
                    const transportIdx = this.todoList.findIndex(v => v.code === 'transportTodo')
                    const vehicleReviewIdx = this.todoList[transportIdx].childList.findIndex(v => v.code === 'vehicleReview')
                    this.todoList[transportIdx].childList[vehicleReviewIdx].value = res.data || 0
                }
            })
        },
        getDriverHomePageCount(){
            driverHomePageCount({supplierCode: this.supplier.supplierCode}).then(res => {
                if (res && +res.code === 0) {
                    const transportIdx = this.todoList.findIndex(v => v.code === 'transportTodo')
                    const driverReviewIdx = this.todoList[transportIdx].childList.findIndex(v => v.code === 'driverReview')
                    this.todoList[transportIdx].childList[driverReviewIdx].value = res.data || 0
                }
            })
        },
        onDelete(params) {
            const count = this.moduleList.filter(item => !item.isRemove).length;
            if (count === 1) {
                this.$message.warning('不能全部删除');
                return false;
            }
            params.isRemove = true;
        },
        // 全部公告
        onAllNoticeDetail() {
            const pageParams = {
                path: '/lsrm/supAnnoList',
                query: {}
            };
            this.linkToPointPage(pageParams);
        },
        // 公告列表
        getSupplierNoticeHomePage() {
            const pramas = {
                pageNo: this.pageNo,
                pageSize: 30,
                supplierCode: this.supplier.supplierCode
            };
            let dataList = [];
            let totalCountVal = 0;
            supplierNoticeHomePage(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { list, totalCount } = res.data;
                        totalCountVal = totalCount || 0;
                        if (Array.isArray(list)) {
                            dataList = list;
                        }
                    }
                })
                .finally(() => {
                    this.noticeData.totalCount = totalCountVal;
                    this.noticeData.childList = dataList;
                });
        },
        // 公告列表-项目公告
        getSupplierNoticeHomePageProject() {
            const pramas = {
                pageNo: this.pageNo,
                pageSize: 30,
                supplierCode: this.supplier.supplierCode,
                noticeType: '40'
            };
            let dataList = [];
            let totalCountVal = 0;
            supplierNoticeHomePage(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { list, totalCount } = res.data;
                        totalCountVal = totalCount || 0;
                        if (Array.isArray(list)) {
                            dataList = list;
                        }
                    }
                })
                .finally(() => {
                    this.noticeData.projectTotalCount = totalCountVal;
                    this.noticeData.projectList = dataList;
                });
        },
        // 投标列表
        getBidHomePage() {
            const pramas = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                supplierCode: this.supplier.supplierCode,
                type: this.bidTabsType
            };
            let dataList = [];
            bidHomePage(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        // this.bidTableData
                        const { list } = res.data;
                        if (Array.isArray(list)) {
                            dataList = list;
                        }
                    }
                })
                .finally(() => {
                    this.bidTableData = dataList;
                });
        },
        // 待签署合同列表
        getContractHomePage() {
            const pramas = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                supplierCode: this.supplier.supplierCode,
                type: this.signTabsType
            };
            let dataList = [];
            contractHomePage(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { list } = res.data;
                        if (Array.isArray(list)) {
                            for (const item of list) {
                                item._contractStatus = this.dicData.SRM_CONTRACT_STATUS[item.contractStatus];
                                item._businessType = this.dicData.BID_BUSINESS_TYPE[item.businessType];
                            }
                            dataList = list;
                        }
                    }
                })
                .finally(() => {
                    this.signTableData = dataList;
                });
        },
        // 投标数据统计
        getTenderInfoData() {
            getTenderInfo(this.supplier.supplierCode)
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data) {
                            for (const item of this.bidTabsData.childList) {
                                item.num = res.data[item.code] || 0;
                            }
                        }
                    }
                })
                .finally(() => {});
        },
        // 待签署合同数据统计
        getContractInfoData() {
            const params = {
                suppliersCode: this.supplier.supplierCode,
                contractStatus: '30'
            };
            getContractInfo(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        for (const item of this.signTabsData.childList) {
                            if (item.code === 'pendingContractSigning') {
                                item.num = res.data || 0;
                                break;
                            }
                        }
                    }
                })
                .finally(() => {});
        },
        // 仲裁
        getAmsHomePageCount() {
            let resData = {};
            const params = {
                departmentSupplierCode: this.supplier.supplierCode,
                chanelSource: '3'
            };
            selectDealTodoCountOrder(params).then(res => {
                if (res && +res.code === 0) {
                    resData = res.data;
                }
            }).finally(() => {
                for (const item of this.todoList) {
                    if (item.code === 'achievementsTodo') {
                        const supplierCodeCountItem = item.childList.find(item => item.code === 'supplierCodeCount');
                        supplierCodeCountItem.value = resData.supplierCodeCount || 0;
                        break;
                    }
                }
            });
        },
        // 月度绩效统计
        getPerformanceHomePageCount() {
            let resData = {};
            performanceHomePageCount(this.supplier.supplierCode)
                .then(res => {
                    if (res && +res.code === 0) {
                        resData = res.data;
                    }
                })
                .finally(() => {
                    for (const item of this.todoList) {
                        if (item.code === 'achievementsTodo') {
                            const waitSupplierConfirmCountItem = item.childList.find(item => item.code === 'waitSupplierConfirmCount');
                            waitSupplierConfirmCountItem.value = resData.waitSupplierConfirmCount || 0;
                            break;
                        }
                    }
                });
        },
        // 运力待办统计
        getSupplierDriverHomePageCount() {
            let resData = {};
            supplierDriverHomePageCount(this.supplier.supplierCode)
                .then(res => {
                    if (res && +res.code === 0) {
                        resData = res.data;
                    }
                })
                .finally(() => {
                    for (const item of this.todoList) {
                        if (item.code === 'transportTodo') {
                            const childList = item.childList;
                            for (const child of childList) {
                                // eslint-disable-next-line max-depth
                                if (['supplierJoinApplyCount', 'supplierDelegateCount'].includes(child.code)) {
                                    child.value = resData[child.code] || 0;
                                }
                            }
                            break;
                        }
                    }
                });
        },
        async getTmsHomePageCount () {
            const transportList = {
                'dispatchCreateCount': getDispatchCreateCount,
                'dispatchLoadedCount': getDispatchLoadedCount,
                'oneTheWayCount': queryOneTheWayCount,
                'unUploadedCount': queryUnUploadedCount,
                'driverExpenseManage': queryUnconfirmedCount
            };
            const transportData = {};
            for (const [transportCode, transportApi] of Object.entries(transportList)) {
                const res = await transportApi(this.supplier.supplierCode);
                if (res && +res.code === 0) {
                    transportData[transportCode] = res.data;
                }
            };
            for (const item of this.todoList) {
                if (item.code === 'operateTodo' || item.code === 'transportTodo') {
                    const childList = item.childList;
                    for (const child of childList) {
                        // eslint-disable-next-line max-depth
                        if (Object.keys(transportList).includes(child.code)) {
                            child.value = transportData[child.code] || 0;
                        };
                    }
                }
            }
        },
        getConfig() {
            const pramas = {
                subjectType: this.pageId,
                moduleCode: this.moduleCode
            };
            this.loading = true;
            getList
                .get(pramas)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { configName } = res.data;
                        let configNameList = [];
                        if (typeof configName === 'string') {
                            configNameList = configName.split(',');
                        }
                        for (const code of configNameList) {
                            for (const item of moduleList) {
                                // eslint-disable-next-line max-depth
                                if (code === item.code) {
                                    item.isRemove = false;
                                    break;
                                }
                            }
                        }

                        if (configName === undefined) {
                            this.initShowModuleByPermissions();
                        } else {
                            this.hideModuleByPermissions();
                        }
                        // eslint-disable-next-line no-console
                        this.moduleList = moduleList;
                        this.noticeData = moduleList[0];
                        this.bidTabsData = moduleList[1];
                        this.signTabsData = moduleList[2];
                        this.todoList = moduleList.filter(
                            obj => obj.type === 'todo'
                        );
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 没有保存过配置的只要有权限的模块都显示
        initShowModuleByPermissions() {
            this.hasPermissions = false;
            for (const item of moduleList) {
                if (item.code === 'bidNotice' && this.btnPermissions.includes(item.auth)) {
                    item.isRemove = false;
                    this.hasPermissions = true;
                } else if (Array.isArray(item.childList)) {
                    const found = item.childList.find(child => this.btnPermissions.includes(child.auth));
                    if (found) {
                        this.hasPermissions = true;
                        item.isRemove = false;
                    }
                }
            }
        },
        // 判断子模块有没有权限，如果所有子模块都没有权限做隐藏操作
        hideModuleByPermissions() {
            this.hasPermissions = false;
            for (const item of moduleList) {
                if (item.code === 'bidNotice' && this.btnPermissions.includes(item.auth)) {
                    this.hasPermissions = true;
                }
                if (Array.isArray(item.childList) && item.code !== 'bidNotice') {
                    const found = item.childList.find(child => this.btnPermissions.includes(child.auth));
                    if (found) {
                        this.hasPermissions = true;
                    } else {
                        item.isRemove = true;
                    }
                }
            }
        },
        onConfig(params) {
            this.isConfig = !this.isConfig;
            for (const item of this.moduleList) {
                if (params.includes(item.code)) {
                    item.isRemove = false;
                } else {
                    item.isRemove = true;
                }
            }
        },
        onConfiguration() {
            this.isConfig = !this.isConfig;
            if (!this.isConfig) {
                const codeList = [];
                const nameList = [];
                for (const item of this.moduleList) {
                    if (!item.isRemove) {
                        codeList.push(item.code);
                        nameList.push(item.label);
                    }
                }
                if (codeList.length < 1 && this.hasPermissions) {
                    this.$message.warning('页面不能全部删除');
                    return;
                }
                const pramas = {
                    configName: codeList.join(','),
                    configNameCn: nameList.join(','),
                    subjectType: this.pageId,
                    moduleCode: this.moduleCode
                };
                this.loading = true;
                getList
                    .post(pramas)
                    .then(res => {
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        onAddModule() {
            const allList = [];
            const selectList = [];
            for (const item of this.moduleList) {
                const row = { label: item.label, code: item.code };
                if (item.type !== 'notice') {
                    for (const child of item.childList) {
                        // eslint-disable-next-line max-depth
                        if (this.btnPermissions.includes(child.auth)) {
                            allList.push(row);
                            // eslint-disable-next-line max-depth
                            if (!item.isRemove) {
                                selectList.push(item.code);
                            }
                            break;
                        }
                    }
                } else {
                    if (this.btnPermissions.includes(item.auth)) {
                        allList.push(row);
                        // eslint-disable-next-line max-depth
                        if (!item.isRemove) {
                            selectList.push(item.code);
                        }
                    }
                }
            }
            this.$refs.configDialog.open(
                allList,
                selectList,
                this.pageId,
                this.moduleCode
            );
        },
        // 招标tabs 头部点击跳转
        onBidSubChange(params) {
            const pageParams = { path: '/lsrm/myBidding', query: {} };
            // 已报名待购标书
            if (params.code === 'pendingTender') {
                // bidStatus: "30"  项目状态=标书通过
                // supplierBidStatus: "2"  报名状态=报名通过
                pageParams.query = {
                    supplierBidStatus: '2',
                    bidStatus: '30'
                };
            } else if (params.code === 'bidPaid') { // 待缴纳投标保证金
                // bidStatus: "30"  项目状态=标书通过
                // supplierBidStatus: "2"  报名状态=标书已购
                pageParams.query = {
                    supplierBidStatus: '3',
                    bidStatus: '30'
                };
            } else if (params.code === 'sealedQuotation') { // 待盖章应标文件
                // bidStatus: "30"  项目状态=标书通过
                // supplierBidStatus: "11"  报名状态=应标文件盖章中
                pageParams.query = {
                    supplierBidStatus: '11',
                    bidStatus: '30'
                };
            } else if (params.code === 'toQuote') { // 待报价
                // bidStatus: "50"  项目状态=标书发布
                pageParams.query = {
                    bidStatus: '50'
                };
            }

            this.linkToPointPage(pageParams);
        },
        // 切换招标tabs 查询列表
        onBidTabsChange(params) {
            // 已报名待购标书
            if (params.code === 'pendingTender') {
                this.bidTabsType = BIDTABSCONST.SIGNUP;
            } else if (params.code === 'bidPaid') { // 待缴纳投标保证金
                this.bidTabsType = BIDTABSCONST.BOND;
            } else if (params.code === 'sealedQuotation') { // 待盖章应标文件
                this.bidTabsType = BIDTABSCONST.SEALSTAMP;
            } else if (params.code === 'toQuote') { // 待报价
                this.bidTabsType = BIDTABSCONST.QUOTATION;
            }
            this.getTenderInfoData();
            this.getBidHomePage();
        },
        // 签署tabs 头部点击跳转
        onSignSubChange(params) {
            let pageParams = { path: '', query: {} };
            params.pageParams && (pageParams = { ...pageParams, ...params.pageParams });
            // 待签署合同
            if (params.code === 'pendingContractSigning') {
                pageParams.path = '/lsrm/contractSigning';
                // 合同状态=待盖章
                pageParams.query = {
                    contractStatus: '30'
                };
            }

            this.linkToPointPage(pageParams);
        },
        // 切换签署tabs 查询列表
        onSignTabsChange(params) {
            // 待签署合同
            if (params.code === 'pendingContractSigning') {
                this.signTabsType = SIGNTABSCONST.TOBESIGNED;
                this.getContractHomePage();
                this.getContractInfoData();
            } else if (params.code === 'noPaymentContractDeposit') {
                // 待支付合同押金
                this.$refs.noPaymentContractDepositTableRef.getData();
            }
        },
        onView() {},
        // 签署合同列表查看
        onSignView(params) {
            const pageParams = {
                path: '/lsrm/contractSigning',
                query: {
                    contractCode: params.contractCode
                }
            };

            this.linkToPointPage(pageParams);
        },
        // 招标列表查看
        onBidView(params) {
            const pageParams = {
                path: '/lsrm/myBidding',
                query: {
                    noticeCode: params.bidNo
                }
            };
            this.linkToPointPage(pageParams);
        },
        // todo跳转查看
        onTodoView(params) {
            let pageParams = {
                path: '',
                query: {}
            };
            params.pageParams && (pageParams = { ...pageParams, ...params.pageParams });
            // 司机加入申请
            if (params.code === 'supplierJoinApplyCount') {
                // 申请结果=待处理(10)
                pageParams.path = '/lsrm/driverAddSupplier';
                pageParams.query = { applyStatus: '10' };
            } else if (params.code === 'driverReview') {
                this.$store.commit('setMipNum', 1);
                // 司机复核不通过
                pageParams.path = '/lsrm/driverInfo';
                pageParams.query = { reviewStatus: '30' };
            } else if (params.code === 'vehicleReview') {
                this.$store.commit('setMipNum', 1);
                // 车辆复核不通过
                pageParams.path = '/lsrm/vehicleInfo';
                pageParams.query = { reviewStatus: '30' };
            } else if (params.code === 'supplierDelegateCount') { // 司机委派函
                pageParams.path = '/lsrm/driverDelegateLetter';
                // 供应商签署状态=未签署(0)
                pageParams.query = { supplierPushStatusList: '0', from: 'homePage' };
            } else if (params.code === 'waitSupplierConfirmCount') { // 月度绩效
                pageParams.path = '/lsrm/legalPerform';
                // 绩效状态=待供应商确认(2)
                pageParams.query = { performanceStatus: '2' };
            } else if (params.code === '2') {
                pageParams.path = '/lsrm/legalPerform';
                // 绩效状态=待供应商确认(2)
                pageParams.query = { performanceStatus: '20' };
            } else if (params.code === 'supplierCodeCount') {
                pageParams.path = '/outPage/problemListManage';
                // 待申诉状态
                pageParams.query = { abnormalOrderStatusList: '20' };
            } else if (params.code === 'dispatchCreateCount') {
                pageParams.path = '/otp/dispatch-center';
                // 待调车
                pageParams.query = { transportStatus: '10' };
            } else if (params.code === 'dispatchLoadedCount') {
                pageParams.path = '/otp/dispatch-order';
                // 待发车
                pageParams.query = { dispatchStatus: '0,10,20,30' };
            } else if (params.code === 'oneTheWayCount') {
                pageParams.path = '/otp/dispatch-order';
                // 待抵达
                pageParams.query = { dispatchStatus: '40' };
            } else if (params.code === 'unUploadedCount') {
                pageParams.path = '/otp/receipt-center';
                // 待上传回单
                pageParams.query = { receiptStatus: '0' };
            } else if (params.code === 'driverExpenseManage') {
                pageParams.path = '/otp/transport-center/driver-expense-manage';
                // 司机运费
                pageParams.query = { confirmStatus: '0' };
            }

            this.linkToPointPage(pageParams);
        },
        findValueRecursive(arr, allList) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i]['resourceType'] === 2) {
                    allList.push(arr[i]['frontUrl']);
                } else if (Array.isArray(arr[i]['subResources'])) {
                    const result = this.findValueRecursive(
                        arr[i]['subResources'],
                        allList
                    ); // 递归查找
                    if (result) return result; // 如果找到，返回结果
                }
            }
            return null; // 没有找到匹配的对象，返回null
        },
        linkToPointPage(page) {
            if (!this.authLinkList.includes(page.path)) {
                this.$message.warning('您无对应菜单权限，无法访问！');
                return;
            }
            setTimeout(() => {
                this.$router.push({
                    path: page.path,
                    query: page.query
                });
            }, 0);
        }
    }
};
</script>
<style lang="less">
@import './styles/index.less';
</style>
